export const importId = process.env.VUE_APP_IMPORT_CLIENT_ID
export default {};